<template>
  <div
    :class="{
      'page-container--indent': indent,
      'page-container--small': small,
      'page-container--middle': middle,
      'page-container--extra': extra
    }"
    :style="{ minHeight: normalizeSize(minHeight), maxWidth: normalizeSize(custom) }"
    class="page-container"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'AppPageContainer',
  props: {
    indent: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    middle: {
      type: Boolean,
      default: false
    },
    extra: {
      type: Boolean,
      default: false
    },
    minHeight: {
      type: [Number, String],
      default: 80
    },
    custom: {
      type: [Number, String]
    }
  },
  methods: {
    normalizeSize(value) {
      return typeof value === 'number' ? `${value}px` : value
    }
  }
}
</script>

<style lang="sass" scoped>
.page-container
  position: relative
  max-width: 900px

.page-container--extra
  max-width: 1080px

.page-container--middle
  max-width: 700px

.page-container--small
  max-width: 500px

.page-container--indent
  margin: 30px 0
</style>